import React, { useState } from 'react';
import { Col } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams } from 'react-router-dom';

import { SubAbasTeds, SubAbasTedsNovo } from './subabasTeds';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import EditableTable from '../../../../components/EditableTable';
import Input from '../../../../components/InputNew';
import Select from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import ModalTwo from '../../../../components/ModalTwo';
import SubAbas from '../../../../components/SubAbas';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { ProaqDestaque } from '../../../../modules/types/Proaq';
import { LogData } from '../../../../modules/types/types';
import { useNivelCriticidade } from '../../../../services/enum/useNivelCriticidade';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
} from '../../../../utils/functions';
import {
  fieldObjectProaq,
  valoresExibidosProaq,
} from '../../ProcessosAquisitivos/auxiliarProaq';
import {
  dataItensPautas,
  headersContratosPautas,
  headersPautasItens,
} from '../contratos/auxiliarContratos';

// Dados do usuário
//Dados do usuário
const user = getUser();
const userID = user.sub;
const entity = ENTITY.ENTITY_Proaq_Destaque;

const TedsPautas: React.FC = () => {
  // const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  let subAbas;
  const NivelCriticidade = useNivelCriticidade();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [logData] = useState<LogData>();
  const [, setDestaqueId] = useState<string>('');
  const [updating, setUpdating] = useState<boolean>(false);
  const [data] = useState<any>();
  const [formDestaque, setFormDestaque] = useState<ProaqDestaque>({
    id: 0,
    descricao: '',
    nivelCriticidade: 0,
    observacoes: '',
    titulo: '',
    proaqId: parseInt(fichaID, 10),
    usuarioId: userID,
  });

  //Subabas
  if (fichaID !== 'undefined') {
    subAbas = SubAbasTeds(fichaID);
  } else {
    subAbas = SubAbasTedsNovo;
  }

  let tituloModal = '';
  if (updating) {
    tituloModal = 'Pauta de Entrega';
  } else {
    tituloModal = 'Pauta de Entrega';
  }
  const iconeModal = 'account_tree';

  //Buscar dados
  // const fetchData = async (id: string) => {
  //   try {
  //     const destaques = await getDestaquesByProaqId(id);
  //     setData(destaques);
  //   } catch (error) {
  //     console.error('Erro ao obter dados', error);
  //   }
  // };

  // useEffect(() => {
  //   fetchData(fichaID);
  // }, []);

  //Dados da tabela
  const tablePauta = [
    {
      id: 1,
      instrumento: 'Contrato',
      numeroInstrumento: '048/25',
      parcela: '2',
      numeroPauta: '2',
      produto: 'Nome do Produto Farmacêutico',
      qtdPauta: '204.245',
      valorPauta: '24.044,02',
      qtdEntregue: '80.234',
    },
  ];

  //Dados do Offcanvas
  const offCanvasData = data
    ? data.map((item: any) => ({
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nivelCriticidade: NivelCriticidade[item.nivelCriticidade].label,
        titulo: item.titulo,
        descricao: item.descricao,
        observacoes: item.observacoes,
      }))
    : [];

  const exportData = data
    ? data.map((item: any) => ({
        //Dados da entidade
        id: item.id,
        nivelCriticidade: NivelCriticidade[item.nivelCriticidade].label,
        titulo: item.titulo,
        descricao: item.descricao,
        observacoes: item.observacoes,

        //Dados do Fornecedor
        proaq: item.proaq.id,
        denominacaoGenerica:
          item.proaq.denominacaoGenerica &&
          item.proaq.denominacaoGenerica != null
            ? item.proaq.denominacaoGenerica.denominacaoGenerica
            : null,
        KitProdutoDAF:
          item.proaq.KitProdutoDAF && item.proaq.KitProdutoDAF != null
            ? item.proaq.KitProdutoDAF.nomeKit
            : null,
        //Logs
        dataRegistro: item.dataRegistro,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioRegistro: formataNomeMeioSiglas(
          item.usuarioRegistro.nomeCompleto,
        ),
        usuarioAtualizacao: formataNomeMeioSiglas(
          item.usuarioAtualizacao.nomeCompleto,
        ),
        usuarioUltimaVisualizacao: formataNomeMeioSiglas(
          item.usuarioUltimaVisualizacao.nomeCompleto,
        ),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
      }))
    : [];

  //Funções Handle

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    const newValue = parseInt(value, 10);

    if (name == 'nivelCriticidade') {
      setFormDestaque({
        ...formDestaque,
        nivelCriticidade: newValue,
      });
    } else {
      setFormDestaque((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearForm = () => {
    setFormDestaque({
      ...formDestaque,
      id: 0,
      descricao: '',
      nivelCriticidade: 0,
      observacoes: '',
      titulo: '',
      proaqId: parseInt(fichaID, 10),
      usuarioId: userID,
    });
  };

  const handleShowModal = () => {
    setShowModal((show) => !show);
  };

  const handleClickInserirNovo = () => {
    handleClearForm();
    setUpdating(false);
    handleShowModal();
  };

  const handleRowClick = (id: string) => {
    setDestaqueId(id);
    setUpdating(true);
    setShowModal(true);
  };

  const handleCreate = async () => {
    alert('handleCreate');
  };

  const handleUpdate = async () => {
    alert('handleUpdate');
  };

  const handleDelete = async () => {
    alert('handleDelete');
  };

  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/proaq/teds"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            // backgroundColor: '#E1ECFE',
            backgroundColor: '#C5D4EB',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <ModalTwo
          icone={iconeModal}
          tituloModal={tituloModal}
          open={showModal}
          onHide={handleShowModal}
        >
          <WorkspaceFicha>
            <Log {...logData} />
            <BoxConteudo boxTitulo="Identificação da Pauta">
              <CustomRow style={{ marginTop: '10px' }}>
                <CustomCol width="200px">
                  <Input
                    name="titulo"
                    value="Entregue Parcial"
                    id="titulo"
                    label="Status"
                    onChange={handleChange}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="160px">
                  <Input
                    name="titulo"
                    value="Contrato"
                    id="titulo"
                    label="Tipo de Instrumento"
                    onChange={handleChange}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="150px">
                  <Input
                    name="titulo"
                    value="042/25"
                    id="titulo"
                    label="Nº Instrumento"
                    onChange={handleChange}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="100px">
                  <Input
                    name="titulo"
                    value="4"
                    id="titulo"
                    label="Nº Parcela"
                    onChange={handleChange}
                    readonly
                    textAlign="right"
                  />
                </CustomCol>
                <CustomCol width="100px">
                  <Input
                    name="titulo"
                    value="7"
                    id="titulo"
                    label="Nº da Pauta"
                    onChange={handleChange}
                    readonly
                    textAlign="right"
                  />
                </CustomCol>
                <CustomCol>
                  <Select
                    name="nivelCriticidade"
                    value={formDestaque.nivelCriticidade}
                    options={NivelCriticidade}
                    onChange={handleChange}
                    label="Produto Farmacêutico"
                  />
                </CustomCol>
              </CustomRow>
              <CustomRow>
                <CustomCol width="200px">
                  <Input
                    name="titulo"
                    value="2.000.000"
                    id="titulo"
                    label="Qtd Total Pauta"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="200px">
                  <Input
                    name="titulo"
                    value="1.000.000"
                    id="titulo"
                    label="Qtd Total Entregue"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="110px">
                  <Input
                    name="titulo"
                    value="50,0%"
                    id="titulo"
                    label="% Entregue"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="100px"></CustomCol>
                <CustomCol width="150px">
                  <Input
                    name="titulo"
                    value="500"
                    id="titulo"
                    label="Fator Embalagem"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="150px">
                  <Input
                    name="titulo"
                    value="4.000"
                    id="titulo"
                    label="Total Embalagens"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="75px"></CustomCol>
                <CustomCol width="150px">
                  <Input
                    name="titulo"
                    value="01/09/2025"
                    id="titulo"
                    label="Prazo Final"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="150px">
                  <Input
                    name="titulo"
                    value="09/08/2025"
                    id="titulo"
                    label="Data 1ª Entrega"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="150px">
                  <Input
                    name="titulo"
                    value="24/08/2025"
                    id="titulo"
                    label="Data Última Entrega"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol></CustomCol>
              </CustomRow>
            </BoxConteudo>

            <BoxConteudo boxTitulo="Itens da Pauta" fechado>
              <EditableTable
                headers={headersPautasItens}
                data={dataItensPautas}
                onDataChange={(newData) =>
                  console.log('Dados atualizados:', newData)
                }
              />
            </BoxConteudo>

            <BoxConteudo boxTitulo="Observações Gerais" fechado>
              <CustomRow>
                <Col>
                  <Input
                    id="observacoes"
                    type="textarea"
                    name="observacoes"
                    value={formDestaque.observacoes}
                    linhas={3}
                    onChange={handleChange}
                  />
                </Col>
              </CustomRow>
            </BoxConteudo>
            <BarraInferiorBotoes>
              {updating ? (
                <WorkspaceBotoes
                  delete
                  onClickDelete={handleDelete}
                  save
                  onClickSave={handleUpdate}
                />
              ) : (
                <WorkspaceBotoes inserir onClickInserir={handleCreate} />
              )}
            </BarraInferiorBotoes>
          </WorkspaceFicha>
        </ModalTwo>

        <Tabela
          dataTable={tablePauta}
          headers={headersContratosPautas}
          displayValues={valoresExibidosProaq}
          dataOffCanvas={offCanvasData}
          onRowClick={handleRowClick}
          botaoAbrirOffCanvas={false}
          showPagination={false}
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          onClickDownload={() =>
            ExportToExcel(
              exportData,
              valoresExibidosProaq,
              fieldObjectProaq,
              'sisaf_proaq_destaques.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
          inserir
          onClickInserir={handleClickInserirNovo}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default TedsPautas;
